<div class="container">
    <div class="row">
        <div class=" col-lg-12 ">
            <mat-card appearance="outlined">
                <mat-card-header>
                    <mat-card-title>
                        Import Kundenstamm-/Vertragsdaten
                    </mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <mat-stepper orientation="vertical" #stepper [linear]="true">
                        <mat-step [stepControl]="step1Form">
                            <ng-template matStepLabel>Schritt 1: Kundenstammdaten hochladen</ng-template>
                            <div class="row">
                                <div class="col-sm-12">
                                    <mat-expansion-panel expanded="false">
                                        <mat-expansion-panel-header>
                                            <mat-panel-title>
                                                Wie muss die Tabelle aufgebaut sein?
                                            </mat-panel-title>
                                        </mat-expansion-panel-header>
                                        <ol>
                                            <li>Kundennummer</li>
                                            <li>Anrede: "Herr" und "Frau" wird unterstützt</li>
                                            <li>Titel: Z.B. "Dr."</li>
                                            <li>Vorname: Nach Möglichkeit Paare vermeiden z.B.: "Max und Martina"</li>
                                            <li>Nachname</li>
                                            <li>Geburtsdatum: Muss im Format "TT.MM.JJJJ hh:mm:ss" angegeben werden.
                                                Z.B. "01.01.1970
                                                00:00:00"
                                            </li>
                                            <li>Adresse: Voller Straßename inkl. Hausnummer und Zusatz</li>
                                            <li>PLZ: Excel schneidet manchmal die führende 0 ab. Z.B. Statt 04356 -&gt;
                                                4356</li>
                                            <li>Ort</li>
                                            <li>E-Mail: optional</li>
                                            <li>Telefon: optional</li>
                                            <li>Mobil: optional</li>
                                        </ol>

                                        <button mat-button color="primary" (click)="downloadDummyData(0)">
                                            <mat-icon>cloud_download</mat-icon>
                                            Testdaten herunterladen...
                                        </button>

                                    </mat-expansion-panel>
                                    <mat-expansion-panel>
                                        <mat-expansion-panel-header>
                                            <mat-panel-title>
                                                Warum werden die hochgeladenen Daten falsch angezeigt?
                                            </mat-panel-title>
                                        </mat-expansion-panel-header>
                                        <ul>
                                            <li>Sie haben versehentlich eine falsche Datei hochgeladen.
                                            </li>
                                            <li>Umlaute (ä,à,ô,ß) werden nicht korrekt angezeigt, ändern Sie bitte das
                                                Encoding der Kundendatei auf UTF-8 (ohne BOM).
                                                Bei Problemen das Encoding zu ändern, nutzen Sie beispielsweise
                                                <a target="_blank" href="https://notepad-plus-plus.org/">Notepad++</a>
                                                <br>
                                                <img [src]="encodingImageLink">
                                            </li>
                                            <li>Die Spaltenanzahl ist nicht genau 12 und daher nicht korrekt.</li>
                                            <li>Bitte vermeiden Sie die Verwednung des Semikolns innerhalb der Felder,
                                                da dies als
                                                Trennzeichen
                                                fungiert.</li>
                                            <li>Es wurde als CSV-Trenner kein Semikolon verwendet.</li>
                                            <li>Das Geburtsdatum wurde nicht im Format "TT.MM.JJJJ hh:mm:ss" angegeben.
                                            </li>
                                            <li>Bei der PLZ wurde die "0" zu Beginn weggekürzt.</li>
                                        </ul>
                                    </mat-expansion-panel>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12 marginTop2Rem marginBottom2Rem">
                                    <div ngx-dropzone [accept]="'*'" [multiple]="false" (change)="onSelect($event)">
                                        <ngx-dropzone-label>
                                            <div>
                                                <h3>CSV-Datei hierher ziehen</h3>
                                                <h5>ODER</h5>
                                                <button mat-raised-button color="accent">Durchsuchen</button>
                                            </div>
                                        </ngx-dropzone-label>
                                        <ngx-dropzone-preview ngProjectAs="ngx-dropzone-preview"
                                            *ngFor="let f of filesUserData" [file]="f" [removable]="true"
                                            (removed)="onRemove(f)">
                                            <ngx-dropzone-label>{{ f.name }}</ngx-dropzone-label>
                                        </ngx-dropzone-preview>
                                    </div>
                                </div>
                            </div>

                            <button mat-raised-button color="primary" matStepperNext
                                [disabled]=" this.filesUserData.length == 0" (click)="handleCustomerFileInput()">Weiter</button>
                        </mat-step>

                        <mat-step [stepControl]="step2Form">
                            <ng-template matStepLabel>Schritt 2: Vertragsdaten hochladen</ng-template>
                            <mat-expansion-panel expanded="false">
                                <mat-expansion-panel-header>
                                    <mat-panel-title>
                                        Wie muss die Tabelle aufgebaut sein?
                                    </mat-panel-title>
                                </mat-expansion-panel-header>
                                <ol>
                                    <li>Kundennummer</li>
                                    <li>Vertragstyp: Bei dem Versorgungsart unterstützen wir "S" für Strom, "G"
                                        für Gas, "H" für
                                        Wärme und
                                        "W"
                                        für Wasser.
                                    </li>
                                    <li>Vertragsnummer: Nummer des Liefervertrags.</li>
                                    <li>Zählernummer</li>
                                    <li>Gültig von: Das Datumsfeld muss im Format "TT.MM.JJJJ hh:mm:ss"
                                        angegeben werden.</li>
                                    <li>Gültig bis: Das Datumsfeld muss im Format "TT.MM.JJJJ hh:mm:ss"
                                        angegeben werden.</li>
                                    <li>Status: Bei dem Vertragsstatus unterstützen wir "2" für "laufend", "3"
                                        für "gekündigt"
                                        und "4"
                                        für
                                        "beendet".
                                    </li>
                                </ol>

                                <button mat-button color="primary" (click)="downloadDummyData(1)">
                                    <mat-icon>cloud_download</mat-icon>
                                    Testdaten herunterladen...
                                </button>

                            </mat-expansion-panel>

                            <mat-expansion-panel>
                                <mat-expansion-panel-header>
                                    <mat-panel-title>
                                        Warum werden die hochgeladenen Daten falsch angezeigt?
                                    </mat-panel-title>
                                </mat-expansion-panel-header>
                                <ul>
                                    <li>Sie haben versehentlich eine falsche Datei hochgeladen.
                                    </li>
                                    <li>Umlaute (ä,à,ô,ß) werden nicht korrekt angezeigt, ändern Sie bitte das
                                        Encoding der Kundendatei auf UTF-8 (ohne BOM).
                                        Bei Problemen das Encoding zu ändern, nutzen Sie beispielsweise
                                        <a target="_blank" href="https://notepad-plus-plus.org/">Notepad++</a>
                                        <br>
                                        <img [src]="encodingImageLink">
                                    </li>
                                    <li>Die Spaltenanzahl ist nicht genau 7 und daher nicht korrekt.</li>
                                    <li>Bitte vermeiden Sie die Verwednung des Semikolns innerhalb der Felder,
                                        da dies als
                                        Trennzeichen
                                        fungiert.</li>
                                    <li>Es wurde als CSV-Trenner kein Semikolon verwendet.</li>
                                    <li>Das Geburtsdatum wurde nicht im Format "TT.MM.JJJJ hh:mm:ss" angegeben.
                                    </li>
                                </ul>
                            </mat-expansion-panel>

                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="row">
                                        <div class="col-sm-12 marginTop2Rem marginBottom2Rem">
                                            <div ngx-dropzone [accept]="'*'" [multiple]="false"
                                                (change)="onSelectContractData($event)">
                                                <ngx-dropzone-label>
                                                    <div>
                                                        <h3>CSV-Datei hierher ziehen</h3>
                                                        <h5>ODER</h5>
                                                        <button mat-raised-button color="accent">Durchsuchen</button>
                                                    </div>
                                                </ngx-dropzone-label>
                                                <ngx-dropzone-preview ngProjectAs="ngx-dropzone-preview"
                                                    *ngFor="let f of filesContractData" [file]="f" [removable]="true"
                                                    (removed)="onRemoveContractData(f)">
                                                    <ngx-dropzone-label>{{ f.name }}</ngx-dropzone-label>
                                                </ngx-dropzone-preview>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <button mat-raised-button color="primary" matStepperPrevious>Zurück</button>
                            <button mat-raised-button color="primary" matStepperNext
                                [disabled]="this.filesUserData.length == 0 || this.filesContractData.length == 0"
                                class="oneStepForwardBtn" (click)="handleContractFileInput()">Weiter</button>
                        </mat-step>
                        <mat-step>
                            <ng-template matStepLabel>Schritt 3: Überprüfung/Import starten</ng-template>
                            <div class="row">
                                <div class="col-sm-12 marginBottom2Rem">
                                    Vorschau Kundendaten (200 Datensätze)
                                    <mat-form-field class="full-width">
                                        <input matInput (keyup)="filterCustomerData($event.target.value)"
                                            placeholder="Suchen...">
                                    </mat-form-field>
                                    <div class="table-container mat-elevation-z2">
                                        <table mat-table [dataSource]="previewCustomerData" matSort
                                            class="mat-elevation-z2">
                                            <ng-container matColumnDef="number">
                                                <th mat-header-cell *matHeaderCellDef>
                                                    #
                                                </th>
                                                <td mat-cell *matCellDef="let element; let i = index;">
                                                    {{i+1}}
                                                </td>
                                            </ng-container>
                                            <ng-container matColumnDef="customerNumber">
                                                <th mat-header-cell *matHeaderCellDef>
                                                    Kundennummer
                                                </th>
                                                <td mat-cell *matCellDef="let element">
                                                    {{element.customerNumber}}
                                                </td>
                                            </ng-container>
                                            <ng-container matColumnDef="salutation">
                                                <th mat-header-cell *matHeaderCellDef>
                                                    Anrede
                                                </th>
                                                <td mat-cell *matCellDef="let element">
                                                    <span>
                                                        {{element.salutation }}
                                                    </span>
                                                </td>
                                            </ng-container>
                                            <ng-container matColumnDef="title">
                                                <th mat-header-cell *matHeaderCellDef>
                                                    Titel
                                                </th>
                                                <td mat-cell *matCellDef="let element">
                                                    <span>
                                                        {{element.title }}
                                                    </span>
                                                </td>
                                            </ng-container>
                                            <ng-container matColumnDef="firstName">
                                                <th mat-header-cell *matHeaderCellDef>
                                                    Vorname
                                                </th>
                                                <td mat-cell *matCellDef="let element">
                                                    <span>
                                                        {{element.firstName }}
                                                    </span>
                                                </td>
                                            </ng-container>
                                            <ng-container matColumnDef="lastName">
                                                <th mat-header-cell *matHeaderCellDef>
                                                    Nachname
                                                </th>
                                                <td mat-cell *matCellDef="let element">
                                                    <span>
                                                        {{element.lastName }}
                                                    </span>
                                                </td>
                                            </ng-container>
                                            <ng-container matColumnDef="birthday">
                                                <th mat-header-cell *matHeaderCellDef>
                                                    Geburtsdatum
                                                </th>
                                                <td mat-cell *matCellDef="let element">
                                                    <span>
                                                        {{element.birthday }}
                                                    </span>
                                                </td>
                                            </ng-container>

                                            <ng-container matColumnDef="street">
                                                <th mat-header-cell *matHeaderCellDef>
                                                    Adresse
                                                </th>
                                                <td mat-cell *matCellDef="let element">
                                                    <span>
                                                        {{element.street }}
                                                    </span>
                                                </td>
                                            </ng-container>

                                            <ng-container matColumnDef="postcode">
                                                <th mat-header-cell *matHeaderCellDef>
                                                    PLZ
                                                </th>
                                                <td mat-cell *matCellDef="let element">
                                                    <span>
                                                        {{element.postcode }}
                                                    </span>
                                                </td>
                                            </ng-container>

                                            <ng-container matColumnDef="city">
                                                <th mat-header-cell *matHeaderCellDef>
                                                    Ort
                                                </th>
                                                <td mat-cell *matCellDef="let element">
                                                    <span>
                                                        {{element.city }}
                                                    </span>
                                                </td>
                                            </ng-container>

                                            <ng-container matColumnDef="email">
                                                <th mat-header-cell *matHeaderCellDef>
                                                    E-Mail
                                                </th>
                                                <td mat-cell *matCellDef="let element">
                                                    <span>
                                                        {{element.email }}
                                                    </span>
                                                </td>
                                            </ng-container>


                                            <ng-container matColumnDef="phone">
                                                <th mat-header-cell *matHeaderCellDef>
                                                    Telefon
                                                </th>
                                                <td mat-cell *matCellDef="let element">
                                                    <span>
                                                        {{element.phone }}
                                                    </span>
                                                </td>
                                            </ng-container>

                                            <ng-container matColumnDef="mobile">
                                                <th mat-header-cell *matHeaderCellDef>
                                                    Mobil
                                                </th>
                                                <td mat-cell *matCellDef="let element">
                                                    <span>
                                                        {{element.mobile }}
                                                    </span>
                                                </td>
                                            </ng-container>

                                            <tr mat-header-row *matHeaderRowDef="customerColumns; sticky: true"></tr>
                                            <tr mat-row *matRowDef="let row; columns: customerColumns;let i = index">
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12 marginBottom2Rem">
                                    Vorschau (200 Datensätze)
                                    <mat-form-field class="full-width">
                                        <input matInput (keyup)="filterContractData($event.target.value)"
                                            placeholder="Suchen...">
                                    </mat-form-field>
                                    <div class="table-container mat-elevation-z2">
                                        <table mat-table [dataSource]="previewContractData" matSort
                                            class="mat-elevation-z2">
                                            <ng-container matColumnDef="number">
                                                <th mat-header-cell *matHeaderCellDef>
                                                    #
                                                </th>
                                                <td mat-cell *matCellDef="let element; let i = index;">
                                                    {{i+1}}
                                                </td>
                                            </ng-container>
                                            <ng-container matColumnDef="customerNumber">
                                                <th mat-header-cell *matHeaderCellDef>
                                                    Kundennummer
                                                </th>
                                                <td mat-cell *matCellDef="let element">
                                                    {{element.customerNumber}}
                                                </td>
                                            </ng-container>
                                            <ng-container matColumnDef="contractType">
                                                <th mat-header-cell *matHeaderCellDef>
                                                    Vertragstyp
                                                </th>
                                                <td mat-cell *matCellDef="let element">
                                                    {{element.contractType}}
                                                </td>
                                            </ng-container>
                                            <ng-container matColumnDef="contractNumber">
                                                <th mat-header-cell *matHeaderCellDef>
                                                    Vertragsnummer
                                                </th>
                                                <td mat-cell *matCellDef="let element">
                                                    {{element.contractNumber}}
                                                </td>
                                            </ng-container>
                                            <ng-container matColumnDef="measurePointNumber">
                                                <th mat-header-cell *matHeaderCellDef>
                                                    Zählernummer
                                                </th>
                                                <td mat-cell *matCellDef="let element">
                                                    {{element.measurePointNumber}}
                                                </td>
                                            </ng-container>
                                            <ng-container matColumnDef="validFrom">
                                                <th mat-header-cell *matHeaderCellDef>
                                                    Gültig von
                                                </th>
                                                <td mat-cell *matCellDef="let element">
                                                    {{element.validFrom}}
                                                </td>
                                            </ng-container>
                                            <ng-container matColumnDef="validTill">
                                                <th mat-header-cell *matHeaderCellDef>
                                                    Gültig bis
                                                </th>
                                                <td mat-cell *matCellDef="let element">
                                                    {{element.validTill}}
                                                </td>
                                            </ng-container>
                                            <ng-container matColumnDef="state">
                                                <th mat-header-cell *matHeaderCellDef>
                                                    Status
                                                </th>
                                                <td mat-cell *matCellDef="let element">
                                                    {{element.state}}
                                                </td>
                                            </ng-container>
                                            <tr mat-header-row *matHeaderRowDef="contractColumns; sticky: true"></tr>
                                            <tr mat-row *matRowDef="let row; columns: contractColumns;let i = index">
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <button mat-raised-button color="primary" matStepperPrevious>Zurück</button>
                            <button mat-raised-button color="primary" matStepperNext class="oneStepForwardBtn"
                                (click)="startImport()">Upload</button>
                        </mat-step>
                    </mat-stepper>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
</div>